import { z } from "zod";

export const PromotionsBaseSchema = z.object({
  promotion_id: z.string().max(255, "L'ID de promotion ne peut pas dépasser 255 caractères").nullable().optional(),
  promotion_code: z.string().max(255, "Le code de promotion ne peut pas dépasser 255 caractères").nullable().optional(),
  quantity: z.string().max(255, "La quantité ne peut pas dépasser 255 caractères").nullable().optional(),
  start_date: z.date().nullable().optional(),
  end_date: z.date().nullable().optional(),
  type: z.string().max(255, "Le type ne peut pas dépasser 255 caractères").nullable().optional(),
  value: z.string().max(255, "La valeur ne peut pas dépasser 255 caractères").nullable().optional(),
});

export const PromotionsSchema = PromotionsBaseSchema.extend({
  id: z.number().int().positive(),
});

export const PromotionsCreateSchema = PromotionsBaseSchema.pick({
  promotion_id: true,
  promotion_code: true,
  quantity: true,
  start_date: true,
  end_date: true,
  type: true,
  value: true,
});

export const PromotionsUpdateSchema = z.object({
  id: z.number().int().positive(),
  promotion_id: z.string().max(255, "L'ID de promotion ne peut pas dépasser 255 caractères").nullable().optional(),
  promotion_code: z.string().max(255, "Le code de promotion ne peut pas dépasser 255 caractères").nullable().optional(),
  quantity: z.string().max(255, "La quantité ne peut pas dépasser 255 caractères").nullable().optional(),
  start_date: z.date().nullable().optional(),
  end_date: z.date().nullable().optional(),
  type: z.string().max(255, "Le type ne peut pas dépasser 255 caractères").nullable().optional(),
  value: z.string().max(255, "La valeur ne peut pas dépasser 255 caractères").nullable().optional(),
});

export const PromotionsListResponseSchema = z.object({
  data: z.array(PromotionsSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export const PromotionsResponseSchema = z.object({
  data: PromotionsSchema,
  message: z.string().optional(),
});

export const PromotionsSelectSchema = z.object({
  id: z.number().int().positive().optional(),
  promotion_id: z.string().optional(),
  promotion_code: z.string().optional(),
  type: z.string().optional(),
  start_date: z.date().optional(),
  end_date: z.date().optional(),
  activeOnly: z.boolean().default(false),
});

export type Promotions = z.infer<typeof PromotionsSchema>;
export type PromotionsCreateInput = z.infer<typeof PromotionsCreateSchema>;
export type PromotionsUpdateInput = z.infer<typeof PromotionsUpdateSchema>;
export type PromotionsSelectInput = z.infer<typeof PromotionsSelectSchema>;

// Form-specific types for frontend
export type PromotionsFormData = PromotionsCreateInput;

export type PromotionsEditFormData = Omit<PromotionsUpdateInput, 'id'>;

// Utility types for different UI states
export type PromotionsDisplayItem = Pick<Promotions, 'id' | 'promotion_code' | 'type' | 'value' | 'start_date' | 'end_date'>;
export type PromotionsSelectOption = Pick<Promotions, 'id' | 'promotion_code'>;
export type PromotionsTableItem = Pick<Promotions, 'id' | 'promotion_id' | 'promotion_code' | 'quantity' | 'type' | 'value' | 'start_date' | 'end_date'>;

export type PromotionsResponse = z.infer<typeof PromotionsResponseSchema>;
export type PromotionsListResponse = z.infer<typeof PromotionsListResponseSchema>;

export const validatePromotionsCreate = (data: unknown) => {
  return PromotionsCreateSchema.safeParse(data);
};

export const validatePromotionsUpdate = (data: unknown) => {
  return PromotionsUpdateSchema.omit({ id: true }).safeParse(data);
};

export const validatePromotionsSelect = (data: unknown) => {
  return PromotionsSelectSchema.safeParse(data);
};
